<p class="mat-display-2">
  <ng-content></ng-content>
</p>
